<template>
  <div class="form-field form-checklist" :rel="name"
       v-bind:class="{'form-required': requiredForm, 'form-checklist-radio': !isMultiple, 'form-disabled':isDisabled}">
    <div class="form-label" v-if="hasLabelVue">
      <label>{{ label }}</label>
    </div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input">
      <div class="form-input-wrapper" v-bind:class="{'block': displayClass == 'block'}">
        <label v-if="showHasAll">
          <input type="checkbox" v-model="internalAll" :value="true" @change="changeInternalValue($event)"
                 :disabled="isDisabled"/>
          <span>
                        <span class="color" style="background:#000;"><i class="icon icon-icon_check"></i></span>
                        <strong>{{ internalAllLabel }}</strong>
                    </span>
        </label>
        <label v-for="item in options">
          <input type="checkbox" v-model="internalValue" :id="item[propId]" :value="item[propId]"
                 @change="change($event)" :disabled="isDisabled"/>
          <span>
                        <span class="color"
                              v-bind:style="{background: item[propColor], borderColor: item[propColor]}"><i
                            class="icon icon-icon_check"></i></span>
                        <strong>{{ item[propName] }}</strong>
                        <p v-if="item[propDescription]">{{ item[propDescription] }}</p>
                    </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: ['value', 'label', 'hint', 'name', 'display', 'description', 'ident', 'color', 'placeholder', 'multiple', 'default', 'options', 'callback', 'required', 'all', 'hasAllLabel', 'showHasAll', 'hasLabel', 'disabled'],
  data: function () {
    return {
      internalValue: '',
      requiredForm: false,
      internalAll: false,
      internalAllLabel: null
    }
  },
  created: function () {
    this.internalAllLabel = this.hasAllLabel ? this.hasAllLabel : 'Tous'
    this.internalAll = this.all
    this.isMultiple = this.multiple == true || this.multiple == 'true' ? true : false;
    this.internalValue = this.setValue(this.value)
    this.onChange = this.callback ? true : false;
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.propName = this.name ? this.name : "name"
    this.propId = this.ident ? this.ident : "id"
    this.propColor = this.color ? this.color : 'color'
    this.propDescription = this.description ? this.description : 'description'
    this.displayClass = this.display ? this.display : 'inline'
    this.hasLabelVue = this.label ? true : false
    this.setDisabled(this.disabled)

    this.setDefault(this.default);
  },
  methods: {
    change: function (e) {
      console.log("change", e.target.checked, e.target.value)
      if (!this.isMultiple) {
        this.internalValue = [];
        if (e.target.checked) {
          this.internalValue = [e.target.value];
          //console.log("change updated", e.target.checked, e.target.value)
        }
      }
    },
    changeInternalValue: function (e) {
      if (e.target.checked) {
        //console.log("changeInternalValue", e.target.checked, e.target.value)
        this.internalValue = [];
      }
    },
    getValue: function (str) {
      if (str !== null && str !== undefined && this.options) {
        for (let item of this.options) {
          //alert((typeof str === "object" || typeof str === 'function') && (str !== null)?"object":"string")
          let id = (typeof str === "object" || typeof str === 'function') && (str !== null) ? str.id.toString().toLowerCase() : str.toString().toLowerCase();
          //console.log("####getValue", item.id, item.id.toString().toLowerCase(), id)
          if (item.id !== null && item.id !== undefined && item.id.toString().toLowerCase() == id) {
            return item.id;
          }
        }
      }
      return null
    },
    setValue: function (v) {
      let tmp = Array.isArray(v) ? v : [v];
      let tmpInternalvalue = []
      for (let item of tmp) {
        let value = this.getValue(item)
        console.log("####setValue", item, value)
        if (value !== null) {
          tmpInternalvalue.push(value)
        }
      }
      if (this.has_all) {
        tmpInternalvalue = []
      }
      return tmpInternalvalue;
    },
    setDefault: function (str) {
      if (str !== null && str !== undefined && this.options) {
        for (let item of this.options) {
          if (item.id !== null && item.id !== undefined && item.id.toString().toLowerCase() == str.toString().toLowerCase()) {
            //console.log("####setDefault", item.id, str, item.id.toString().toLowerCase() == str.toString().toLowerCase())
            this.internalValue = [item.id];
          }
        }
      }
    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      //console.log("=====> Checklist before", newVal, this.internalValue)
      if (newVal !== this.internalValue) {
        //console.log("=====> Checklist", newVal)
        this.internalValue = this.setValue(newVal)
      }
    },
    'default'(newVal, oldVal) {
      this.setDefault(newVal);
    },
    'internalValue'(newVal, oldVal) {
      if (this.internalValue && this.internalValue.length) {
        this.internalAll = false;
      }
      if( newVal !== oldVal )
      {
        this.$emit('update:coucou', this.internalValue)
        this.$emit('input', this.internalValue);
        //this.$emit('update:all', this.internalAll)
        //console.log("update model", this.internalValue)
        if (this.onChange) {
          this.callback(this.internalValue)
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Checklist.vue